export const ageRanges = [
  { range: [63.0, 86.0], color: 'var(--range-yellow-low)' },
  { range: [60.0, 63.0], color: 'var(--range-red-high)' },
  { range: [56.0, 60.0], color: 'var(--range-yellow-low)' },
  { range: [54.0, 56.0], color: 'var(--range-green-high)' },
  { range: [51.0, 54.0], color: 'var(--range-green-high)' },
  { range: [48.0, 51.0], color: 'var(--range-green-low)' },
  { range: [45.0, 48.0], color: 'var(--range-green-low)' },
  { range: [42.0, 45.0], color: 'var(--range-green-low)' },
  { range: [39.0, 42.0], color: 'var(--range-green-high)' },
  { range: [37.0, 39.0], color: 'var(--range-yellow-medium)' },
  { range: [34.0, 37.0], color: 'var(--range-yellow-medium)' },
  { range: [31.0, 34.0], color: 'var(--range-yellow-low)' },
  { range: [28.0, 31.0], color: 'var(--range-yellow-low)' },
  { range: [25.0, 28.0], color: 'var(--range-yellow-low)' },
  { range: [0, 25.0], color: 'var(--range-red-high)' },
];

export const rtRanges = [
  { range: [836.0, 2312.0], color: 'var(--range-green-high)' },
  { range: [688.0, 836.0], color: 'var(--range-green-low)' },
  { range: [600.0, 688.0], color: 'var(--range-green-low)' },
  { range: [538.0, 600.0], color: 'var(--range-yellow-low)' },
  { range: [484.0, 538.0], color: 'var(--range-green-low)' },
  { range: [436.0, 484.0], color: 'var(--range-green-low)' },
  { range: [392.0, 436.0], color: 'var(--range-yellow-medium)' },
  { range: [344.0, 392.0], color: 'var(--range-yellow-low)' },
  { range: [300.0, 344.0], color: 'var(--range-yellow-low)' },
  { range: [254.0, 300.0], color: 'var(--range-yellow-medium)' },
  { range: [204.0, 254.0], color: 'var(--range-yellow-medium)' },
  { range: [152.0, 204.0], color: 'var(--range-yellow-medium)' },
  { range: [103.0, 152.0], color: 'var(--range-red-low)' },
  { range: [48.0, 103.0], color: 'var(--range-red-high)' },
  { range: [0, 48.0], color: 'var(--range-red-low)' },
];

export const dtRanges = [
  { range: [197.0, 641.0], color: 'var(--range-green-high)' },
  { range: [156.0, 197.0], color: 'var(--range-green-medium)' },
  { range: [132.0, 156.0], color: 'var(--range-yellow-low)' },
  { range: [112.0, 132.0], color: 'var(--range-green-high)' },
  { range: [96.0, 112.0], color: 'var(--range-green-medium)' },
  { range: [84.0, 96.0], color: 'var(--range-green-low)' },
  { range: [72.0, 84.0], color: 'var(--range-green-low)' },
  { range: [60.0, 72.0], color: 'var(--range-yellow-medium)' },
  { range: [48.0, 60.0], color: 'var(--range-yellow-medium)' },
  { range: [36.0, 48.0], color: 'var(--range-yellow-high)' },
  { range: [25.0, 36.0], color: 'var(--range-red-low)' },
  { range: [20.0, 25.0], color: 'var(--range-red-high)' },
  { range: [11.0, 20.0], color: 'var(--range-red-low)' },
  { range: [0, 11.0], color: 'var(--range-red-medium)' },
];

export const otRanges = [
  { range: [445.0, 1136.0], color: 'var(--range-green-medium)' },
  { range: [381.0, 445.0], color: 'var(--range-yellow-low)' },
  { range: [336.0, 381.0], color: 'var(--range-green-low)' },
  { range: [300.0, 336.0], color: 'var(--range-green-high)' },
  { range: [267.0, 300.0], color: 'var(--range-green-medium)' },
  { range: [236.0, 267.0], color: 'var(--range-green-low)' },
  { range: [208.0, 236.0], color: 'var(--range-yellow-low)' },
  { range: [180.0, 208.0], color: 'var(--range-yellow-low)' },
  { range: [152.0, 180.0], color: 'var(--range-yellow-high)' },
  { range: [125.0, 152.0], color: 'var(--range-yellow-high)' },
  { range: [98.0, 125.0], color: 'var(--range-yellow-medium)' },
  { range: [72.0, 98.0], color: 'var(--range-red-low)' },
  { range: [44.0, 72.0], color: 'var(--range-red-low)' },
  { range: [14.0, 44.0], color: 'var(--range-red-high)' },
  { range: [0, 14.0], color: 'var(--range-red-low)' },
];
